<template>
	<div>
		<div class="bigBox">
			<div class="leftCont">
				<div class="banners ssst">
					<div class="mendio1">
						<div class="Intro topFar1">我们给你不仅仅是软件</div>
						<div class="Intro">是持续发展的客源</div>
						<div class="Intro">是深挖的客户关系价值</div>
						<div class="Intro">还有流量变现业务延升的发展</div>
						<el-button type="text" class="Ufree" @click="dvSaas = true"><span style="color: #fff !important;margin-left: unset !important;">立即体验(外卖)</span></el-button>
						<el-button type="text" class="Ufree" @click="dvQuan = true"><span style="color: #fff !important;margin-left: unset !important;">立即体验(MOMI互推)</span></el-button>
						<el-button type="text" class="Ufree" @click="dvStore = true"><span style="color: #fff !important;margin-left: unset !important;">立即体验(商城)</span></el-button>
						<!-- <el-carousel trigger="click">
							<el-carousel-item v-for="(item,index) in imgs" :key="index">
								<img mode="widthFix" :src="item" class="reotaPic"/>
							</el-carousel-item>
						</el-carousel> -->
					</div>
				</div>
				<div class="pBox">
					<div class="ptitle">3大优势</div>

					<div class="pcont">
						<div class="pLeft">
							<div class="pLTitle">Part1</div>
							<div class="pLcont"><strong style="color: #333;">通过：</strong>MOMI互推——流量的搬运工,以异业合作小程序做拓客工具
								，以卡券相互推送进行流量转换、流量活跃、流量储蓄,全面为商家打造私域流量池</div>
							<div class="pLcont"><strong style="color: #333;">实现：</strong>流量+收益”双赢模式，客户流通盘活商圈，拉新、留锁、升、挖，打开商务渠道，
								分润轻松管理，商家增值赋能，消费者利益最大化</div>
						</div>
						<div class="emtyImg">
							<img mode="widthFix" src="../assets/images/img13.jpg" class="pImg" />
						</div>
					</div>

					<div class="pcont-bk">
						<div class="pcont">
							<div class="emtyImg">
								<img mode="widthFix" src="../assets/images/img14.png" class="pImg" />
							</div>
							<div class="pReft">
								<div class="pLTitle">Part2</div>
								<div class="pLcont"><strong style="color: #333;">通过：</strong>MOMI外卖 & 一体化的互联网餐饮经营平台
									运营升级—丰富的营销拓客工具
									服务升级—满足场景需求预约系统
									价值升级—完善的会员管理体系
									营销升级—便捷的员工分销管理系统</div>
								<div class="pLcont"><strong style="color: #333;">实现：</strong>赋能门店销售能力，深挖客户价值
									不浪费每一次不易获得的流量，通过流量的存续运营，再获得更多的流量</div>
							</div>
						</div>
					</div>
					<div class="pcont">
						<div class="pLeft">
							<div class="pLTitle">Part3</div>
							<div class="pLcont"><strong style="color: #333;">通过：</strong>MOMI商城—移动网店，把门店开到微信上，各种秒杀项目，商品随时销售
								直播电商—现场直播导购、项目案列分享、链接商城导购，一键打通商城在线直播营销，品牌曝光，新产品发布........</div>
							<div class="pLcont"><strong style="color: #333;">实现：</strong>商家产品项目服务延展，品牌曝光，客户连接升级，流量变现</div>
						</div>
						<div class="emtyImg">
							<img mode="widthFix" src="../assets/images/img15.png" class="pImg" />
						</div>
					</div>
				</div>
				<!-- <div class="RotaContBox">
					<el-tabs v-model="activeName" @tab-click="handleClick">
					    <el-tab-pane label="全部" name="1">
							<caseBox></caseBox>
						</el-tab-pane>
					    <el-tab-pane label="美容美体" name="2">
							<caseBox></caseBox>
						</el-tab-pane>
					    <el-tab-pane label="皮肤管理" name="3">
							<caseBox></caseBox>
						</el-tab-pane>
					    <el-tab-pane label="美甲美睫" name="4">
							<caseBox></caseBox>
						</el-tab-pane>
						<el-tab-pane label="美发养发" name="5">
							<caseBox></caseBox>
						</el-tab-pane>
						<el-tab-pane label="医疗美容" name="6">
							<caseBox></caseBox>
						</el-tab-pane>
						<el-tab-pane label="医疗诊所" name="7">
							<caseBox></caseBox>
						</el-tab-pane>
						<el-tab-pane label="中医理疗" name="8">
							<caseBox></caseBox>
						</el-tab-pane>
						<el-tab-pane label="其他" name="9">
							<caseBox></caseBox>
						</el-tab-pane>
					</el-tabs>
				</div> -->
				<msg-foot></msg-foot>
			</div>
			<right-cont :activeIndex="activeIndex"></right-cont>
			<!-- <right-cont :dialogVisible="dvSaas"></right-cont>
			<right-cont :dialogVisible="dvQuan"></right-cont>
			<right-cont :dialogVisible="dvStore"></right-cont> -->
		</div>
		<el-dialog title="" :visible.sync="dvSaas" width="30%" :before-close="handleClose">
			<div>
				<img class="pop-pic" src="../assets/images/saas_try.jpg" />
				<div class="free-use">扫码立即体验</div>
			</div>
		</el-dialog>
		<el-dialog title="" :visible.sync="dvQuan" width="30%" :before-close="handleClose">
			<div>
				<img class="pop-pic" src="../assets/images/qr_tool.jpg" />
				<div class="free-use">扫码立即体验</div>
			</div>
		</el-dialog>
		<el-dialog title="" :visible.sync="dvStore" width="30%" :before-close="handleClose">
			<div>
				<img class="pop-pic" src="../assets/images/store_try.jpg" />
				<div class="free-use">扫码立即体验</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import msgFoot from '../components/msgFoot.vue'
	import rightCont from '../components/rightCont.vue'
	import caseBox from '../components/caseBox.vue'
	export default {
		components: {
			msgFoot,
			rightCont,
			caseBox
		},
		data() {
			return {
				activeName: '1',
				activeIndex: '3',
				dvSaas: false,
				dvQuan: false,
				dvStore: false,
				imgs: []
			}
		},
		methods: {
			handleClick(tab, event) {
				console.log(tab.name, event);
			}
		},
		mounted() {
			window.scroll(0, 0);
		}
	}
</script>

<style>
	@media screen and (min-width: 1200px) {
		.pcont {
			margin-bottom: unset !important;
		}

		.el-tabs__header {
			margin: unset !important;
		}

		.el-tabs__nav-wrap::after {
			height: 1px !important;
		}

		.el-tabs__item {
			height: 70px !important;
			line-height: 70px !important;
		}

		.banners {
			width: 100%;
		}

		.RotaContBox {
			padding: 0 40px;
		}

		.el-carousel__container {
			height: 330px !important;
		}

		/* .el-carousel__container{
			height: 338px !important;
		} */
		.reotaPic {
			width: 100%;
			height: unset !important;
		}

		.el-carousel__button {
			width: 8px !important;
			height: 8px !important;
			border-radius: 50% !important;
		}

		.el-carousel__item {
			z-index: 0 !important;
		}



		.stt {
			margin-top: 56px;
		}
	}

	@media screen and (max-width: 1200px) {
		.banners {
			width: 100%;
		}

		.reotaPic {
			width: 100%;
			height: unset !important;
		}

		.RotaContBox {
			padding: 5vw;
		}

		.el-carousel__container {
			height: 39vw !important;
		}

		.el-carousel__button {
			width: 5px !important;
			height: 5px !important;
			border-radius: 50% !important;
		}
	}
</style>
